export default __webpack_public_path__ + "static/media/work2.4eff2d5d.png";